import React from "react";

const CallToAction = () => {
  return (
    <section className="bg-white text-black py-16 px-6 md:px-24">
      <div className="container mx-auto flex flex-col lg:flex-row items-center gap-12">

        {/* Left Image (Swimming image — unchanged) */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src="/Images/swimming_img.png"
            alt="Sports Turf & Swimming Area"
            className="w-full max-w-4xl h-64 md:h-80 lg:h-[500px] rounded-lg shadow-lg object-cover"
          />
        </div>

        {/* Right Content */}
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h2 className="text-3xl md:text-4xl font-extrabold bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent">
            Build Your Dream Sports Facility With ZajraGreen
          </h2>

          <p className="text-lg md:text-xl mb-10 text-gray-700">
            From football turfs and box cricket arenas to swimming areas and multi-sport flooring,
            ZajraGreen delivers high-quality, durable sports infrastructure trusted across India.
          </p>

          <h5 className="mb-8 text-lg md:text-xl text-gray-800">
            Premium materials • Expert installation • Long-lasting durability
          </h5>

          <button
            className="bg-green-600 text-white font-semibold py-3 px-6 rounded-lg shadow hover:bg-green-700 transition-colors duration-300"
          >
            Get a Free Consultation
          </button>
        </div>

      </div>
    </section>
  );
};

export default CallToAction;
